import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty, find } from 'lodash';
import { fetchContractsSnapshot } from '../../app-main/actions/contracts';
import { Spinner } from 'shared-components/decorators/spinner';
import { BookingOvertimeMain } from '../../app-bookings-overtime/booking-overtime-main';
import { formValueSelector } from 'redux-form';
import { BOOKING_OVERTIME_FORM } from '../components/reduxForms/constants/formNames';

class BookingOvertimeContainer extends Component {
  componentDidMount () {
    if (this.props.accessToken) {
      const { dispatch, routeParams, accessToken } = this.props;
      const bookingID = get(routeParams, 'bookingID', '');
      dispatch(fetchContractsSnapshot(bookingID, accessToken));
    }
  }

  componentWillReceiveProps (nextProps) {
    const { accessToken, profile, booking } = nextProps;
    const bookingHostID = get(booking, 'booking.host_id');

    // if user logs out, redirect to sign in
    if (!accessToken) {
      window.location.href = '/';
    }
    // only booking host can access overtime form
    if (bookingHostID && (bookingHostID !== profile.SSOid)) {
      window.location.href = '/inbox';
    }
  }

  render () {
    const { isFetching, contracts } = this.props;
    const isFetchingContracts = isEmpty(contracts);
    return (
      <div className="BookingOvertimeContainer ps-container-lg-margin ps-container-fixed">
        { (isFetching || isFetchingContracts) ?
          <div className="spinner-container">
            <Spinner additionalStyle="gray" />
          </div>
          : <BookingOvertimeMain {...this.props} />
        }
      </div>
    );
  }
}

BookingOvertimeContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired
};

const selector = formValueSelector(BOOKING_OVERTIME_FORM);

function mapStateToProps (state) {
  const { auth, profile, contract } = state;
  const hoursValue = selector(state, 'hours');
  const multiplierValue = selector(state, 'multiplier');
  const contractsQuote = get(contract, 'quote', []);
  const contracts = get(contract, 'data.contracts',[]);
  const spaceRentalContract = find(contracts, { type: 'SPACE_RENTAL' }) || {};
  const booking = get(spaceRentalContract, 'meta.booking', {});

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  return {
    auth,
    profile,
    isFetching,
    hoursValue,
    multiplierValue,
    contracts,
    spaceRentalContract,
    booking,
    contractsQuote: contractsQuote
  };
}

export default connect(mapStateToProps)(BookingOvertimeContainer);
